<div
    class="vp-margin-top-10"
>
    <div
        *ngIf="hasIndividualValues"
        class="ip-coverage-amount-container"
    >
        <h5

            [id]="'tiered-network-individual-header'"
            class="h5 tiered-coverage-title"
        >{{ 'Individual' | translate }}</h5>

        <div *ngFor="let tier of tiers">
            <tiered-coverage-amount
                *ngIf="tier?.individual"
                [id]="'tier-'+ (tier?.name ?? '') +'-coverage-individual'"
                [tieredCoverage]="tier?.individual ?? []"
                [name]="tier?.name ?? ''"
            ></tiered-coverage-amount>
        </div>
    </div>

    <div
        *ngIf="hasFamilyValues"
        class="ip-coverage-amount-container"
    >
        <h5
            [id]="'tiered-network-individual-header'"
            class="h5 tiered-coverage-title"
        >{{ 'Family' | translate }}</h5>
        <div *ngFor="let tier of tiers">
            <tiered-coverage-amount
                *ngIf="tier?.family"
                [id]="'tier-'+ (tier?.name ?? '') +'-coverage-family'"
                [tieredCoverage]="tier?.family ?? []"
                [name]="tier?.name ?? ''"
            ></tiered-coverage-amount>
        </div>
    </div>
</div>
